<div class="support">
  <!-- FAQ. -->
  <div class="support__form-wrapper">
    <app-faq></app-faq>
  </div>

  <!-- Форма обратной связи -->
  <div class="support__form-wrapper">
    <app-send-email-form></app-send-email-form>
  </div>

  <!-- Кнопка для удаление текущего профиля -->
  <app-delete-auth-user-link class="link"></app-delete-auth-user-link>

  <!-- Документы из конфигурации -->
  <app-config-documents [pageName]="'support'" [showNoData]="false"></app-config-documents>
</div>
